<div class="card" *ngIf="loading">
    <div class="card-body flex justify-center" style="margin-top: 20px;">
        <app-preloader ></app-preloader>
    </div>
</div>
<ng-container  *ngIf="!loading">
    <div class="card">
        <div class="card-body">
            <h6 class="text-lg text-gray-500 font-semibold mb-6">Devices</h6>
            <div class="relative overflow-x-auto" *ngIf="userDevices.length > 0">
                <table class="text-left w-full whitespace-nowrap text-sm text-gray-500">
                    <thead>
                        <tr class="text-sm">
                            <th scope="col" class="p-4 font-semibold">Device ID</th>
                            <th scope="col" class="p-4 font-semibold">Device</th>
                            <th scope="col" class="p-4 font-semibold">Itagtip Version</th>
                            <th scope="col" class="p-4 font-semibold">Last Updated</th>
                            <th scope="col" class="p-4 font-semibold">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let device of userDevices ">
                            <td class="p-4 text-sm">
                                <div class="flex gap-6 items-center">
                                    <div class="flex flex-col gap-1 text-gray-500">
                                        <h3 class=" font-bold">{{ device._id }}</h3>
                                    </div>
                                </div>
                            </td>
                            <td class="p-4">
                                <h3 class="font-medium">{{ device.manufacturer | titlecase }} ({{device.operatingSystem}} -
                                    v{{device.operatingSystemVersion}}) </h3>
                            </td>
                            <td class="p-4">
                                <h3 class="font-medium">Itagtip v{{ device.appVersion || 0.0 }}</h3>
                            </td>
                            <td class="p-4">
                                <h3 class="font-medium">{{ device.installDate | date:"medium"}}</h3>
                            </td>
                            <td>
                                <button type="button"
                                    class="py-2 px-4 inline-flex items-center gap-x-2 font-semibold rounded-2xl border text-gray border-gray-200 hover:border-gray-200 hover:text-white hover:bg-gray-500"
                                    routerLink="/portal/user/{{userId}}/locations">
                                    <i class="ti ti-map"></i> View locations
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="4">
                                <div class="flex justify-center gap-3 mt-4 mb-4">
                                    <button
                                        class="px-4 py-2 bg-gray-200 text-gray-800 text-base font-medium rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300">
                                        View locations
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="flex justify-center" *ngIf="userDevices.length === 0">
                <img src="./assets/images/profile/no-record-found.png" alt="" class="w-100px h-100px">
            </div>
        </div>
    </div>
</ng-container>